export const JO_STATUS_COMPLETED_ID = 1;
export const JO_STATUS_ACTIVE_ID = 2;
export const JO_STATUS_NOT_STARTED_ID = 3;
export const JO_STATUS_PENDING_ID = 4;
